import { render, staticRenderFns } from "./result-subtitle.vue?vue&type=template&id=f3bc2f4e"
import script from "./result-subtitle.vue?vue&type=script&lang=js"
export * from "./result-subtitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports